import * as login from '../actions/login';

import * as fromEmail from './login-email';
import * as fromSms from './login-sms';

import { createFeatureSelector, createSelector } from '@ngrx/store';


export interface LoginState {
  email: fromEmail.State;
  sms: fromSms.State;
}

export const reducers = {
  email: fromEmail.reducer,
  sms: fromSms.reducer,
};

export const selectLoginState = createFeatureSelector<LoginState>('login');

console.log(selectLoginState);


export const selectEmailState = createSelector(
  selectLoginState,
  (state: LoginState) => state.email,
);

export const selectSmsState = createSelector(
  selectLoginState,
  (state: LoginState) => state.sms,
);


export const getLoginEmailPageForm = createSelector(
  selectEmailState,
  fromEmail.getForm,
);


export const getLoginEmailPagePending = createSelector(
  selectEmailState,
  fromEmail.getPending,
);


export const getLoginEmailPageError = createSelector(
  selectEmailState,
  fromEmail.getError,
);


export const getLoginSmsPageForm = createSelector(
  selectSmsState,
  fromSms.getForm,
);


export const getLoginSmsPagePending = createSelector(
  selectSmsState,
  fromSms.getPending,
);


export const getLoginSmsPageError = createSelector(
  selectSmsState,
  fromSms.getError,
);


export const getLoginSmsPageCaptchaSolved = createSelector(
  selectSmsState,
  fromSms.getCaptchaSolved,
);

export const getLoginSmsPageCodeConfirmed = createSelector(
  selectSmsState,
  fromSms.getCodeConfirmed,
);



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/login/reducers/index.ts